import Vue from 'vue'
import VueRouter from 'vue-router'
import About from '@/views/About'
import store from '@/store'
import goTo from 'vuetify/lib/services/goto'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: About,
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: () => import('../views/signup/SignUpClinic.vue'),
    props: true,
  },
  {
    path: '/signup/donation',
    name: 'SignUpDonation',
    component: () => import('../views/signup/SignUpDonation.vue'),
    props: true,
  },
  {
    path: '/signup/connect',
    name: 'SignUpConnect',
    component: () => import('../views/signup/SignUpConnect.vue'),
    props: true,
  },
  {
    path: '/signup/clinic',
    name: 'SignUpClinic',
    component: () => import('../views/signup/SignUpClinic.vue'),
    props: true
  },
  {
    path: '/signup/appointment',
    name: 'SignUpAppointment',
    component: () => import('../views/signup/SignUpAppointment.vue'),
    props: true
  },
  {
    path: '/signup/review',
    name: 'SignUpReview',
    component: () => import('../views/signup/SignUpReview.vue'),
    props: true
  },
  {
    path: '/signup/clinic/subscribe',
    name: 'SubscribeClinic',
    component: () => import('../views/signup/SubscribeClinicCms.vue'),
    props: true
  },
  {
    path: '/signup/appointment/subscribe',
    name: 'SubscribeAppointment',
    component: () => import('../views/signup/SubscribeAppointment.vue'),
    props: true
  },
  {
    path: '/pay-subscription',
    name: 'PaySubscription',
    component: () => import('../views/PaySubscription.vue'),
  },
  {
    path: '/admin/verify-yearly-subscription-payment',
    name: 'VerifyYearlySubscriptionPayment',
    props: true,
    component: () => import('../views/admin/VerifyYearlySubscriptionPayment.vue'),
  },
  {
    path: '/start/user',
    name: 'InviteSignUp',
    component: () => import('../views/InviteSignUp.vue'),
    props: true,
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: () => import('../views/SignIn.vue'),
    props: true,
  },
  {
    path: '/impersonate',
    name: 'Yadmin',
    component: () => import('../views/Yadmin.vue'),
    props: true,
  },
  {
    path: '/approve-signin/:token',
    name: 'ApproveSignIn',
    component: () => import('../views/ApproveSignIn.vue'),
    props: true,
  },
  {
    path: '/mobile-app',
    name: 'MobileApp',
    component: () => import('../views/MobileApp.vue'),
    props: true,
  },
  {
    path: '/signin/forgot',
    name: 'Forgot',
    component: () => import('../views/Forgot.vue'),
    props: true,
  },
  {
    path: '/signin/verify',
    name: 'Verify',
    component: () => import('../views/Verify.vue'),
    props: true,
  },
  {
    path: '/signin/reset',
    name: 'ResetPassword',
    component: () => import('../views/ResetPassword.vue'),
    props: true,
  },
  {
    path: '/signin/clinic',
    name: 'SignInClinic',
    component: () => import('../views/SignInClinic.vue'),
    props: true,
  },
  {
    path: '/signout',
    name: 'SignOut',
    component: () => import('../views/SignOut.vue'),
  },
  {
    path: '/companies',
    name: 'Companies',
    component: () => import('../views/Companies.vue'),
  },
  {
    path: '/start/company',
    name: 'NewCompany',
    component: () => import('../views/NewCompany.vue'),
  },
  {
    path: '/start/donation',
    name: 'NewDonationOrganization',
    component: () => import('../views/NewDonationOrganization.vue'),
  },
  {
    path: '/start/connect',
    name: 'NewConnectCompany',
    component: () => import('../views/NewConnectCompany.vue'),
  },
  {
    path: '/start/clinic',
    name: 'NewClinicCompany',
    component: () => import('../views/NewClinicCompany.vue')
  },
  {
    path: '/start/appointment',
    name: 'NewAppointmentCompany',
    component: () => import('../views/NewAppointmentCompany.vue')
  },
  {
    path: '/start/review',
    name: 'NewReviewCompany',
    component: () => import('../views/NewReviewCompany.vue')
  },
  {
    path: '/start/purchase-hub',
    name: 'NewPurchaseHubCompany',
    component: () => import('../views/NewPurchaseHubCompany.vue')
  },
  {
    path: '/start/marketing',
    name: 'NewMarketingCompany',
    component: () => import('../views/NewMarketingCompany.vue')
  },
  {
    path: '/invite/:token',
    name: 'AcceptInvite',
    component: () => import('../views/AcceptInvite.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
  },
  {
    path: '/connect/complete',
    name: 'InviteConnectComplete',
    component: () => import('../views/InviteConnectComplete.vue'),
    props: true,
  },
  {
    path: '/stocktake/:id',
    name: 'ClinicStockTakeShare',
    component: () => import('../views/StockTakeShare.vue'),
    props: true,
  },
  {
    path: '/stocktake/:id/summary',
    name: 'ClinicStockTakeSummaryShare',
    component: () => import('../views/StockTakeSummaryShare.vue'),
    props: true,
  },
  {
    path: '/quotation/:slug/:pid',
    name: 'ClinicPurchaseHubQuotationShare',
    component: () => import('../views/PurchaseHubQuotationShare.vue'),
    props: true,
  },
  {
    path: '/admin',
    name: 'AdminHome',
    component: () => import('../views/admin/Home.vue'),
    children: [
      {
        path: '/admin/verify-billing',
        name: 'VerifyBilling',
        component: () => import('../views/admin/VerifyPayment.vue'),
      },
      {
        path: '/admin/prepaid-topup-verify-payment',
        name: 'VerifyPrepaidTopup',
        component: () => import('../views/admin/VerifyPrepaidTopup.vue'),
      },
      {
        path: '/admin/dashboard',
        name: 'Dashboard',
        props: true,
        component: () => import('../views/admin/Dashboard.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', '')
          next()
        },
      },
      // {
      //   path: '/admin/connect/customers',
      //   name: 'ConnectCustomers',
      //   component: () => import('../views/admin/connect/customers/Customers.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'customers')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/customers/upload-csv',
      //   name: 'ConnectCustomersImport',
      //   component: () => import('../views/admin/connect/customers/CustomerUploadCsv.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'customers')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/customers/send-message',
      //   name: 'CustomersSendMessage',
      //   component: () => import('../views/admin/connect/customers/send/SendMessage.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'send_message')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/customers/send-email',
      //   name: 'CustomersSendEmail',
      //   component: () => import('../views/admin/connect/customers/send/SendEmail.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'send_message')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/status',
      //   name: 'ConnectStatus',
      //   component: () => import('../views/admin/connect/customers/status/Status.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'status')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/segments',
      //   name: 'ConnectSegments',
      //   component: () => import('../views/admin/module/segment/Segments.vue'),
      //   props: { os: 'connect' },
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'segments')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/segments/create',
      //   name: 'ConnectSegmentsCreate',
      //   component: () => import('../views/admin/module/segment/CreateSegment.vue'),
      //   props: { os: 'connect' },
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'segments')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/segments/upload-csv',
      //   name: 'ConnectSegmentsUpload',
      //   component: () => import('../views/admin/module/segment/SegmentUploadCsv.vue'),
      //   props: { os: 'connect' },
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'segments')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/segments/:id',
      //   name: 'ConnectSegmentDetail',
      //   props: true,
      //   component: () => import('../views/admin/connect/segments/SegmentDetail.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'segment_detail')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/segments/:id/add-customers',
      //   name: 'ConnectSegmentDetailCustomers',
      //   props: true,
      //   component: () => import('../views/admin/connect/segments/SegmentAddCustomers.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'segment_detail')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/segments/:id/send-message',
      //   name: 'ConnectSegmentSendMessage',
      //   props: true,
      //   component: () => import('../views/admin/connect/segments/send/SegmentSendMessage.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'send_message')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/segments/:id/send-email',
      //   name: 'ConnectSegmentSendEmail',
      //   props: true,
      //   component: () => import('../views/admin/connect/segments/send/SegmentSendEmail.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'send_email')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/tasks',
      //   name: 'ConnectTasks',
      //   component: () => import('../views/admin/connect/tasks/Tasks.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'tasks')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/tasks/:id',
      //   name: 'ConnectTaskDetail',
      //   props: true,
      //   component: () => import('../views/admin/connect/tasks/TaskDetail.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'task_detail')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/users',
      //   name: 'ConnectUsers',
      //   component: () => import('../views/admin/connect/Users.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'users')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/connect/webhook',
      //   name: 'ConnectWebhook',
      //   component: () => import('../views/admin/connect/WebhookIntegration.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'webhook_integration')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/restaurant/pos-setup',
      //   name: 'PosSetup',
      //   props: true,
      //   component: () => import('../views/admin/restaurant/PosSetup.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'pos_setup')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/restaurant/user-access',
      //   name: 'UserAccess',
      //   props: true,
      //   component: () => import('../views/admin/restaurant/UserAccess.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'pos_user_access')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/restaurant/assign-table',
      //   name: 'AssignTable',
      //   props: true,
      //   component: () => import('../views/admin/restaurant/AssignTable.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'assign_table')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/restaurant/payment-settings',
      //   name: 'PaymentSettings',
      //   props: true,
      //   component: () => import('../views/admin/restaurant/PaymentSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'payment_settings')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/restaurant/transactions',
      //   name: 'TransactionHistory',
      //   props: true,
      //   component: () => import('../views/admin/restaurant/Transactions.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'transaction_history')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/restaurant/receipt-template',
      //   name: 'ReceiptTemplate',
      //   props: true,
      //   component: () => import('../views/admin/restaurant/ReceiptTemplate.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'receipt_template')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/restaurant/hardware-settings',
      //   name: 'HardwareSettings',
      //   props: true,
      //   component: () => import('../views/admin/restaurant/HardwareSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'hardware_settings')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/restaurant/menu-categories',
      //   name: 'MenuCategories',
      //   props: true,
      //   component: () => import('../views/admin/restaurant/MenuCategories.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'menu_categories')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/restaurant/table-ordering',
      //   name: 'TableOrdering',
      //   props: true,
      //   component: () => import('../views/admin/restaurant/TableOrdering.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'table_ordering')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/analytics',
      //   name: 'DonationAnalytics',
      //   props: true,
      //   component: () => import('../views/admin/donation/Analytics.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'analytics')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/campaign',
      //   name: 'Campaign',
      //   props: true,
      //   component: () => import('../views/admin/donation/Campaign.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'campaign')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/campaign/:pid',
      //   name: 'ManageCampaign',
      //   props: true,
      //   component: () => import('../views/admin/donation/ManageCampaign.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'manage_campaign')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/donors',
      //   name: 'Donors',
      //   props: true,
      //   component: () => import('../views/admin/donation/Donors.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'donors')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/donors/import',
      //   name: 'DonorsImport',
      //   component: () => import('../views/admin/donation/DonorsImportCustomers.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'donors')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/donors/send-message',
      //   name: 'DonorsSendMessage',
      //   component: () => import('../views/admin/donation/DonorsSendMessage.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'send_message')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/donors/send-email',
      //   name: 'DonorsSendEmail',
      //   component: () => import('../views/admin/donation/DonorsSendEmail.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'send_email')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/fundraisers',
      //   name: 'Fundraisers',
      //   props: true,
      //   component: () => import('../views/admin/donation/Fundraisers.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'fundraisers')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/segments',
      //   name: 'DonationSegments',
      //   component: () => import('../views/admin/module/segment/Segments.vue'),
      //   props: { os: 'donation' },
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'segments')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/segments/create',
      //   name: 'DonationSegmentsCreate',
      //   component: () => import('../views/admin/module/segment/CreateSegment.vue'),
      //   props: { os: 'donation' },
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'segments')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/segments/upload-csv',
      //   name: 'DonationSegmentsUpload',
      //   component: () => import('../views/admin/module/segment/SegmentUploadCsv.vue'),
      //   props: { os: 'donation' },
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'segments')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/segments/:id',
      //   name: 'DonationSegmentDetail',
      //   props: true,
      //   component: () => import('../views/admin/donation/SegmentDetail.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'segment_detail')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/segments/:id/send-message',
      //   name: 'DonationSegmentSendMessage',
      //   props: true,
      //   component: () => import('../views/admin/donation/SegmentSendMessage.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'send_message')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/segments/:id/send-email',
      //   name: 'DonationSegmentSendEmail',
      //   props: true,
      //   component: () => import('../views/admin/donation/SegmentSendEmail.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'send_email')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/segments/:id/add-customers',
      //   name: 'DonationSegmentDetailCustomers',
      //   props: true,
      //   component: () => import('../views/admin/donation/SegmentAddCustomers.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'segments')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/settings',
      //   name: 'DonationSettings',
      //   props: true,
      //   component: () => import('../views/admin/donation/Settings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'settings')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/settings/payment',
      //   name: 'DonationPaymentSettings',
      //   props: true,
      //   component: () => import('../views/admin/donation/settings/PaymentSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'settings')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/settings/general',
      //   name: 'DonationGeneralSettings',
      //   props: true,
      //   component: () => import('../views/admin/donation/settings/GeneralSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'settings')
      //     next()
      //   },
      // },

      // {
      //   path: '/admin/donation/settings/subscription',
      //   name: 'DonationSubscriptionSettings',
      //   props: true,
      //   component: () => import('../views/admin/donation/settings/SubscriptionSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'settings')
      //     next()
      //   },
      // },

      // {
      //   path: '/admin/donation/settings/bills',
      //   name: 'DonationBillsSettings',
      //   props: true,
      //   component: () => import('../views/admin/donation/settings/BillsSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'settings')
      //     next()
      //   },
      // },

      // {
      //   path: '/admin/donation/settings/account',
      //   name: 'DonationAccountSettings',
      //   props: true,
      //   component: () => import('../views/admin/donation/settings/AccountSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'settings')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/settings/marketing-tracking',
      //   name: 'DonationMarketingtSettings',
      //   props: true,
      //   component: () => import('../views/admin/donation/settings/MarketingTrackingSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'settings')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/donation/settings/integration',
      //   name: 'DonationIntegrationSettings',
      //   props: true,
      //   component: () => import('../views/admin/donation/settings/IntegrationSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'settings')
      //     next()
      //   },
      // },
      {
        path: '/admin/clinic/analytics',
        name: 'ClinicAnalytics',
        props: true,
        component: () => import('../views/admin/clinic/Analytics.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'analytics')
          next()
        },
      },
      {
        path: '/admin/clinic/appointment',
        name: 'ClinicAppointment',
        props: true,
        component: () => import('../views/admin/clinic/Appointment.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'appointment')
          next()
        },
      },
      {
        path: '/admin/clinic/appointment/calendar',
        name: 'ClinicAppointmentCalendar',
        props: true,
        component: () => import('../views/admin/clinic/AppointmentCalendar.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'calendar')
          next()
        },
      },
      {
        path: '/admin/clinic/insights',
        name: 'ClinicInsights',
        component: () => import('../views/admin/clinic/insights/Insights.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'insights')
          next()
        },
        children: [
          {
            path: '/admin/clinic/insights/today',
            component: () => import('../views/admin/clinic/insights/Today.vue'),
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'Today')
              next()
            },
          },
          {
            path: '/admin/clinic/insights/sales',
            component: () => import('../views/admin/clinic/insights/Sales.vue'),
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'Sales')
              next()
            },
          },
          {
            path: '/admin/clinic/insights/in-clinic',
            component: () => import('../views/admin/clinic/insights/InClinic.vue'),
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'In-clinic')
              next()
            },
          },
          {
            path: '/admin/clinic/insights/appointments',
            component: () => import('../views/admin/clinic/insights/Appointments.vue'),
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'Appointments')
              next()
            },
          },
          {
            path: '/admin/clinic/insights/reviews',
            component: () => import('../views/admin/clinic/insights/Reviews.vue'),
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'Review')
              next()
            },
          },
          {
            path: '/admin/clinic/insights/payments',
            component: () => import('../views/admin/clinic/insights/Payments.vue'),
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'Payments')
              next()
            },
          },
          {
            path: '/admin/clinic/insights/inventory',
            component: () => import('../views/admin/clinic/insights/Inventory.vue'),
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'Inventory')
              next()
            },
          },
          {
            path: '/admin/clinic/insights/patients',
            component: () => import('../views/admin/clinic/insights/Patients.vue'),
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'Patients')
              next()
            },
          },
        ]
      },
      {
        path: '/admin/clinic/message-template',
        name: 'ClinicMessageTemplate',
        props: true,
        component: () => import('../views/admin/clinic/MessageTemplate.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'edit_message_template')
          next()
        },
      },
      {
        path: '/admin/clinic/patients',
        name: 'ClinicPatientList',
        props: true,
        component: () => import('../views/admin/clinic/Patients.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'patient')
          next()
        },
      },
      {
        path: '/admin/clinic/grouppatients',
        name: 'ClinicGroupPatient',
        props: true,
        component: () => import('../views/admin/clinic/GroupPatients.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'patient')
          next()
        },
      },
      {
        path: '/admin/clinic/leads',
        name: 'ClinicLeadList',
        props: true,
        component: () => import('../views/admin/crm/FollowUp.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'patient')
          next()
        },
      },
      {
        path: '/admin/clinic/patient/:id',
        name: 'ClinicPatientDetails',
        props: true,
        component: () => import('../views/admin/clinic/Patient.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'patient')
          next()
        },
      },
      {
        path: '/admin/clinic/billings',
        name: 'ClinicBillingsList',
        props: true,
        component: () => import('../views/admin/clinic/Billings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'billing')
          next()
        },
      },
      {
        path: '/admin/clinic/einvoice',
        name: 'ConsolidatedEInvoice',
        component: () => import('../views/admin/clinic/ConsolidatedEInvoice.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'consolidated_einvoice')
          next()
        },
      },
      {
        path: '/admin/clinic/review',
        name: 'ClinicReview',
        props: { os: 'clinic' },
        component: () => import('../components/review/listing/ReviewListingPage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'review')
          next()
        }
      },
      {
        path: '/admin/clinic/review/add-invite',
        name: 'Add Invite',
        props: { os: 'review' },
        component: () => import('../views/admin/review/AddInvites.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'review')
          next()
        },
      },
      {
        path: '/admin/clinic/registration',
        name: 'ClinicRegistration',
        props: true,
        component: () => import('../views/admin/clinic/Registration.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'registration')
          next()
        },
      },
      {
        path: '/admin/clinic/reservations-preorders',
        name: 'ClinicReservationsPreorders',
        props: true,
        component: () => import('../views/admin/clinic/ReservationsPreorders.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'reservations & pre-orders')
          next()
        },
      },
      {
        path: '/admin/clinic/inventory-invoices',
        name: 'ClinicInventoryInvoices',
        props: true,
        component: () => import('../views/admin/clinic/InventoryInvoices.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory invoices')
          next()
        },
      },
      {
        path: '/admin/clinic/inventory-invoice',
        name: 'AddInventoryInvoice',
        props: true,
        component: () => import('../views/admin/clinic/InventoryInvoice.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory invoice')
          next()
        },
      },
      {
        path: '/admin/clinic/inventory-invoice/:id',
        name: 'EditInventoryInvoice',
        props: true,
        component: () => import('../views/admin/clinic/InventoryInvoice.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory invoice')
          next()
        },
      },
      {
        path: '/admin/clinic/inventory-list',
        name: 'InventoryList',
        props: true,
        component: () => import('../views/admin/clinic/InventoryList.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory list')
          next()
        },
      },
      {
        path: '/admin/clinic/inventory',
        name: 'ClinicInventory',
        props: true,
        component: () => import('../views/admin/clinic/Inventory.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory')
          next()
        },
      },
      {
        path: '/admin/clinic/medication',
        name: 'NewClinicMedication',
        props: true,
        component: () => import('../views/admin/clinic/Medication.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'medication')
          next()
        },
      },
      {
        path: '/admin/clinic/medication/:id',
        name: 'EditClinicMedication',
        props: true,
        component: () => import('../views/admin/clinic/Medication.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'medication')
          next()
        },
      },
      {
        path: '/admin/clinic/stock-update',
        name: 'StockUpdate',
        props: true,
        component: () => import('../views/admin/clinic/StockUpdate.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'StockUpdate History')
          next()
        },
      },
      {
        path: '/admin/clinic/medication/:id/stock-history',
        name: 'StockHistory',
        props: true,
        component: () => import('../views/admin/clinic/StockHistory.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Stock History')
          next()
        },
      },
      {
        path: '/admin/clinic/packages',
        name: 'ClinicPackages',
        props: true,
        component: () => import('../views/admin/clinic/Packages.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Packages')
          next()
        },
      },
      {
        path: '/admin/clinic/package',
        name: 'AddClinicPackage',
        props: true,
        component: () => import('../views/admin/clinic/Package.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Package')
          next()
        },
      },
      {
        path: '/admin/clinic/package/:id',
        name: 'EditClinicPackage',
        props: true,
        component: () => import('../views/admin/clinic/Package.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Package')
          next()
        },
      },
      {
        path: '/admin/clinic/package/:id/package-history',
        name: 'PackageHistory',
        props: true,
        component: () => import('../views/admin/clinic/PackageHistory.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Package History')
          next()
        },
      },
      {
        path: '/admin/clinic/locations',
        name: 'ClinicInventoryLocation',
        props: true,
        component: () => import('../views/admin/clinic/Locations.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Locations')
          next()
        },
      },
      {
        path: '/admin/clinic/location',
        name: 'AddClinicInventoryLocation',
        props: true,
        component: () => import('../views/admin/clinic/Location.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Location')
          next()
        },
      },
      {
        path: '/admin/clinic/location/:id',
        name: 'EditClinicInventoryLocation',
        props: true,
        component: () => import('../views/admin/clinic/Location.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Location')
          next()
        },
      },
      {
        path: '/admin/clinic/stocktakes',
        name: 'ClinicInventoryStockTake',
        props: true,
        component: () => import('../views/admin/clinic/StockTakes.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Stock take')
          next()
        },
      },
      {
        path: '/admin/clinic/stocktake/:id',
        name: 'AddClinicInventoryStockTake',
        props: true,
        component: () => import('../views/admin/clinic/StockTake.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Stock take')
          next()
        },
      },
      {
        path: '/admin/clinic/stocktake/:id/summary',
        name: 'ClinicInventoryStockTakeSummary',
        props: true,
        component: () => import('../views/admin/clinic/StockTakeSummary.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Stock take')
          next()
        },
      },
      {
        path: '/admin/clinic/branches-warehouses',
        name: 'ClinicBranchesWarehouses',
        props: true,
        component: () => import('../views/admin/clinic/BranchesWarehouses.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Branches & Warehouses')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/review',
        name: 'ClinicReviewSettings',
        props: { os: 'clinic' },
        component: () => import('../components/review/settings/ReviewSettingPage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Review Settings')
          next()
        }
      },
      {
        path: '/admin/clinic/settings/review-api-key',
        name: 'ClinicReviewApiKeySettings',
        component: () => import('../views/admin/review/settings/ApiKey.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Review Settings')
          next()
        }
      },
      {
        path: '/admin/clinic/consultation',
        name: 'ClinicConsultation',
        props: true,
        component: () => import('../views/admin/clinic/Consultation.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Consultation')
          next()
        },
      },
      {
        path: '/admin/clinic/consultation/:pid',
        name: 'ClinicConsultationDetails',
        props: true,
        component: () => import('../views/admin/clinic/ConsultationDetails.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Consultation')
          next()
        }
      },
      {
        path: '/admin/clinic/consultation/:pid/note-fullview',
        name: 'ClinicConsultationNoteFullview',
        props: true,
        component: () => import('../views/admin/clinic/ConsultationNoteFullview.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'ConsultationNote')
          next()
        }
      },
      {
        path: '/admin/clinic/reports/prescription',
        name: 'ClinicPrescriptionReport',
        props: true,
        component: () => import('../views/admin/clinic/reports/PrescriptionReport.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Report')
          next()
        }
      },
      {
        path: '/admin/clinic/reports/sales',
        name: 'ClinicSalesReport',
        props: true,
        component: () => import('../views/admin/clinic/reports/SalesReport.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Report')
          next()
        }
      },
      {
        path: '/admin/clinic/reports/panel',
        name: 'ClinicPanelReport',
        props: true,
        component: () => import('../views/admin/clinic/reports/PanelReport.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Report')
          next()
        }
      },
      {
        path: '/admin/clinic/reports/stock-movement',
        name: 'ClinicStockMovementReport',
        props: true,
        component: () => import('../views/admin/clinic/reports/StockMovementReport.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Report')
          next()
        }
      },
      {
        path: '/admin/clinic/purchase-hub',
        name: 'ClinicPurchaseHub',
        props: true,
        component: () => import('../views/admin/clinic/PurchaseHub.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Purchase Hub')
          next()
        }
      },
      {
        path: '/admin/clinic/marketing',
        name: 'ClinicMarketing',
        props: true,
        component: () => import('../views/admin/clinic/Marketing.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Marketing')
          next()
        }
      },
      {
        path: '/admin/clinic/marketing/offer/create',
        name: 'ClinicCreateOffer',
        props: true,
        component: () => import('../views/admin/clinic/CreateOffer.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Offer')
          next()
        }
      },
      {
        path: '/admin/clinic/marketing/offer/create/:id',
        name: 'ClinicEditOffer',
        props: true,
        component: () => import('../views/admin/clinic/CreateOffer.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Offer')
          next()
        }
      },
      {
        path: '/admin/clinic/marketing/offer/:id',
        name: 'ClinicOfferDetails',
        props: true,
        component: () => import('../views/admin/clinic/OfferDetails.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Offer')
          next()
        }
      },
      {
        path: '/admin/clinic/marketing/offer/preset/:id',
        name: 'CliniPresetOffer',
        props: true,
        component: () => import('../views/admin/clinic/PresetOffer.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Offer')
          next()
        }
      },
      {
        path: '/admin/clinic/marketing/loyalty/settings',
        name: 'ClinicLoyaltySettings',
        props: true,
        component: () => import('../views/admin/clinic/LoyaltySettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Loyalty')
          next()
        }
      },
      {
        path: '/admin/clinic/marketing/review/settings',
        name: 'ClinicMarketingReviewSettings',
        props: { os: 'clinic' },
        component: () => import('../views/admin/clinic/ReviewSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Review Settings')
          next()
        }
      },
      {
        path: '/admin/clinic/reports/panel-invoice',
        name: 'ClinicPanelInvoiceReport',
        props: true,
        component: () => import('../views/admin/clinic/reports/PanelInvoice.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Report')
          next()
        }
      },
      // Panels
      {
        path: '/admin/clinic/panels',
        name: 'ClinicPanels',
        props: true,
        component: () => import('../views/admin/clinic/panel/Panels.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Panels')
          next()
        },
        redirect: '/admin/clinic/panels/claims',
        children: [
          {
            path: 'claims',
            name: 'ClinicPanelClaims',
            component: () => import('../views/admin/clinic/panel/Claims.vue'),
            beforeEnter: (to, from, next) => {
              store.commit('ui/setNavbarTitle', 'Panel Claims')
              next()
            }
          },
          {
            path: 'claim/:id',
            name: 'ClinicPanelClaimDetails',
            props: true,
            component: () => import('../views/admin/clinic/panel/Claim.vue'),
            beforeEnter: (to, from, next) => {
              store.commit('ui/setNavbarTitle', 'Panel Claim Details')
              next()
            }
          }
        ]
      },
      {
        path: '/admin/clinic/panels/settings/claim-message-template',
        name: 'ClinicPanelClaimMessageTemplate',
        props: true,
        component: () => import('../views/admin/clinic/panel/settings/ClaimMessageTemplate.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Claim Message Template')
          next()
        }
      },
      {
        path: '/admin/clinic/invoice/:pid',
        name: 'ClinicInvoice',
        props: true,
        component: () => import('../views/admin/clinic/Invoice.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Invoice')
          next()
        }
      },
      {
        path: '/admin/clinic/checkout/:pid',
        name: 'ClinicCheckout',
        props: true,
        component: () => import('../views/admin/clinic/Checkout.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Checkout')
          next()
        }
      },
      {
        path: '/admin/clinic/reservation/new/:patientId',
        name: 'ClinicReservationNew',
        props: true,
        component: () => import('../views/admin/clinic/ReservationPreorderDetail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Reservation')
          next()
        }
      },
      {
        path: '/admin/clinic/reservation/:reservationId',
        name: 'ClinicReservationView',
        props: true,
        component: () => import('../views/admin/clinic/ReservationPreorderDetail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Reservation')
          next()
        }
      },
      {
        path: '/admin/clinic/preorder/new/:patientId',
        name: 'ClinicPreorderNew',
        props: true,
        component: () => import('../views/admin/clinic/ReservationPreorderDetail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Pre-order')
          next()
        }
      },
      {
        path: '/admin/clinic/preorder/:preorderId',
        name: 'ClinicPreorderView',
        props: true,
        component: () => import('../views/admin/clinic/ReservationPreorderDetail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Pre-order')
          next()
        }
      },
      {
        path: '/admin/clinic/settings/document/templates',
        name: 'ClinicTemplates',
        props: true,
        component: () => import('../views/admin/clinic/DocumentTemplates.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Templates')
          next()
        }
      },
      {
        path: '/admin/clinic/settings/document/template',
        name: 'ClinicTemplate',
        props: true,
        component: () => import('../views/admin/clinic/DocumentTemplate.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Template')
          next()
        }
      },
      {
        path: '/admin/clinic/settings/document/template/:id',
        name: 'ClinicTemplateId',
        props: true,
        component: () => import('../views/admin/clinic/DocumentTemplate.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Template')
          next()
        }
      },
      {
        path: '/admin/clinic/settings/document/drug-label',
        name: 'ClinicDrugLabel',
        props: true,
        component: () => import('../views/admin/clinic/DrugLabel.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Drug Label')
          next()
        }
      },
      {
        path: '/admin/clinic/settings/hardware/printers',
        name: 'ClinicPrinters',
        props: true,
        component: () => import('../views/admin/clinic/Printers.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Printers')
          next()
        }
      },
      {
        path: '/admin/clinic/settings/queue-system',
        name: 'ClinicQueueSystem',
        props: true,
        component: () => import('../views/admin/clinic/QueueSystemSetting.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Queue System')
          next()
        }
      },
      {
        path: '/admin/clinic/settings/facilities',
        name: 'ClinicFacilities',
        props: true,
        component: () => import('../views/admin/clinic/settings/Facilities.vue'),
      },
      {
        path: '/admin/clinic/settings/facilities/:id/edit',
        name: 'ClinicFacilitiesEdit',
        props: true,
        component: () => import('../views/admin/clinic/AddEditFacility.vue'),
      },
      {
        path: '/admin/clinic/settings/new-facility',
        name: 'ClinicAddEditFacility',
        component: () => import('../views/admin/clinic/AddEditFacility.vue'),
      },
      {
        path: '/admin/clinic/review-api-key',
        name: 'ClinicReviewApiKey',
        props: true,
        component: () => import('../views/admin/review/settings/ApiKey.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'API Key')
          next()
        },
      },
      {
        path: '/admin/clinic/segments',
        name: 'ClinicSegment',
        props: true,
        component: () => import('../views/admin/clinic/Segments.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segment')
          next()
        },
      },
      {
        path: '/admin/clinic/segments/create',
        name: 'ClinicSegmentsCreate',
        component: () => import('../views/admin/module/segment/CreateSegment.vue'),
        props: { os: 'clinic' },
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segments')
          next()
        },
      },
      {
        path: '/admin/clinic/segments/upload-csv',
        name: 'ClinicSegmentsUpload',
        component: () => import('../views/admin/module/segment/SegmentUploadCsv.vue'),
        props: { os: 'clinic' },
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segments')
          next()
        },
      },
      {
        path: '/admin/clinic/segments/:id',
        name: 'ClinicSegmentDetail',
        props: true,
        component: () => import('../views/admin/clinic/SegmentDetail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segment_detail')
          next()
        },
      },
      {
        path: '/admin/clinic/segments/:id/send-message',
        name: 'ClinicSegmentSendMessage',
        props: true,
        component: () => import('../views/admin/clinic/SegmentSendMessage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_message')
          next()
        },
      },
      {
        path: '/admin/clinic/segments/:id/send-email',
        name: 'ClinicSegmentSendEmail',
        props: true,
        component: () => import('../views/admin/clinic/SegmentSendEmail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_email')
          next()
        },
      },
      {
        path: '/admin/clinic/segments/:id/add-customers',
        name: 'ClinicSegmentDetailCustomers',
        props: true,
        component: () => import('../views/admin/clinic/SegmentAddCustomers.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'segments')
          next()
        },
      },
      {
        path: '/admin/clinic/manage',
        name: 'ClinicPageSetup',
        props: true,
        component: () => import('../views/admin/clinic/Manage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'manage')
          next()
        },
      },
      {
        path: '/admin/clinic/manage/provider',
        name: 'ClinicNewProvider',
        props: true,
        component: () => import('../views/admin/clinic/Provider.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'new_provider')
          next()
        },
      },
      {
        path: '/admin/clinic/manage/provider/:id',
        name: 'ClinicEditProvider',
        props: true,
        component: () => import('../views/admin/clinic/Provider.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'new_provider')
          next()
        },
      },
      {
        path: '/admin/clinic/services',
        name: 'ClinicServices',
        props: true,
        component: () => import('../views/admin/clinic/Services.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'services')
          next()
        },
      },
      {
        path: '/admin/clinic/service/:id/service-history',
        name: 'ServiceHistory',
        props: true,
        component: () => import('../views/admin/clinic/ServiceHistory.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Service History')
          next()
        },
      },
      {
        path: '/admin/clinic/service',
        name: 'ClinicNewService',
        props: true,
        component: () => import('../views/admin/clinic/Service.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'new_service')
          next()
        },
      },
      {
        path: '/admin/clinic/service/:id',
        name: 'ClinicEditService',
        props: true,
        component: () => import('../views/admin/clinic/Service.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'new_service')
          next()
        },
      },
      {
        path: '/admin/clinic/manage/appointment-service',
        name: 'ClinicNewAppointmentService',
        props: true,
        component: () => import('../views/admin/clinic/AppointmentService.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'new_service')
          next()
        },
      },
      {
        path: '/admin/clinic/manage/appointment-service/:id',
        name: 'ClinicEditAppointmentService',
        props: true,
        component: () => import('../views/admin/clinic/AppointmentService.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'new_service')
          next()
        },
      },
      {
        path: '/admin/clinic/users',
        name: 'ClinicUsers',
        props: true,
        component: () => import('../views/admin/clinic/Users.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'users')
          next()
        },
      },
      {
        path: '/admin/clinic/user-logs',
        name: 'ClinicUserLogs',
        props: true,
        component: () => import('../views/admin/clinic/settings/UserLogs.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'user-logs')
          next()
        },
      },
      {
        path: '/admin/clinic/user',
        name: 'AddUser',
        props: true,
        component: () => import('../views/admin/clinic/AddUser.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'user')
          next()
        },
      },
      {
        path: '/admin/clinic/user/:id',
        name: 'EditUser',
        props: true,
        component: () => import('../views/admin/clinic/EditUser.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'user')
          next()
        },
      },
      {
        path: '/admin/clinic/user-settings',
        name: 'ClinicUserSettings',
        props: true,
        component: () => import('../views/admin/clinic/UserSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'user_settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings',
        name: 'ClinicSettings',
        props: true,
        component: () => import('../views/admin/clinic/Management.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/registration-settings',
        name: 'RegistrationSettings',
        props: true,
        component: () => import('../views/admin/clinic/settings/RegistrationSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/consultation-settings',
        name: 'ConsultationSettings',
        props: true,
        component: () => import('../views/admin/clinic/settings/ConsultationSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/checkout-settings',
        name: 'CheckoutSettings',
        props: true,
        component: () => import('../views/admin/clinic/settings/CheckoutSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/price-tier-settings',
        name: 'PriceTierSettings',
        props: true,
        component: () => import('../views/admin/clinic/settings/PriceTierSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/medicine-settings',
        name: 'MedicineSettings',
        props: true,
        component: () => import('../views/admin/clinic/settings/MedicineSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/supplier-settings',
        name: 'SupplierSettings',
        props: true,
        component: () => import('../views/admin/clinic/settings/SupplierSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/general',
        name: 'ClinicSettingsGeneral',
        props: true,
        component: () => import('../views/admin/clinic/settings/GeneralSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/payment',
        name: 'ClinicSettingsPayment',
        props: true,
        component: () => import('../views/admin/clinic/settings/PaymentSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/analytics',
        name: 'ClinicSettingsAnalytics',
        props: true,
        component: () => import('../views/admin/clinic/settings/Analytics.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/integration',
        name: 'ClinicSettingsIntegration',
        props: true,
        component: () => import('../views/admin/clinic/settings/IntegrationSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/appointment',
        name: 'ClinicSettingsAppointment',
        props: true,
        component: () => import('../views/admin/clinic/settings/Appointment.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/billing/clinic-subscription',
        name: 'ClinicSettingsSubscription',
        props: true,
        component: () => import('../views/admin/clinic/settings/SimpleSubscription.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/billing/clinic-bills',
        name: 'ClinicSettingsBills',
        props: true,
        component: () => import('../views/admin/clinic/settings/BillsSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/account',
        name: 'ClinicSettingsAccount',
        props: true,
        component: () => import('../views/admin/clinic/settings/AccountSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/business-details',
        name: 'SettingsBusinessDetails',
        component: () => import('../views/admin/clinic/settings/BusinessDetailsSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'business_settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/tax',
        name: 'SettingsTax',
        component: () => import('../views/admin/clinic/settings/TaxSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'tax_settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/e-invoice',
        name: 'SettingsEInvoice',
        component: () => import('../views/admin/clinic/settings/EInvoiceSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'e_invoice_settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/payment-gateway',
        name: 'PaymentGateway',
        component: () => import('../views/admin/clinic/settings/PaymentGatewaySettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'payment_gateway_settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/marketing',
        name: 'ClinicSettingsMarketing',
        component: () => import('../views/admin/clinic/settings/MarketingSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'marketing_settings')
          next()
        },
      },
      {
        path: '/admin/clinic/settings/wallet',
        name: 'SettingsWallet',
        component: () => import('../views/admin/clinic/settings/Wallet.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'wallet')
          next()
        },
      },
      {
        path: '/admin/clinic/patients/import',
        name: 'PatientImport',
        component: () => import('../views/admin/clinic/PatientImportCustomers.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'patient')
          next()
        },
      },
      {
        path: '/admin/clinic/patients/send-message',
        name: 'PatientSendMessage',
        component: () => import('../views/admin/clinic/PatientSendMessage.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_message')
          next()
        },
      },
      {
        path: '/admin/clinic/patients/send-email',
        name: 'PatientSendEmail',
        component: () => import('../views/admin/clinic/PatientSendEmail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'send_email')
          next()
        },
      },
      // {
      //   path: '/admin/review/review',
      //   name: 'Review',
      //   props: { os: 'review' },
      //   component: () => import('../components/review/listing/ReviewListingPage.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'review')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/review/general-settings',
      //   name: 'ReviewGeneralSettings',
      //   props: true,
      //   component: () => import('../views/admin/review/GeneralSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'General Settings')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/review/review-settings',
      //   name: 'ReviewSettings',
      //   props: { os: 'review' },
      //   component: () => import('../components/review/settings/ReviewSettingPage.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'Review Settings')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/review/settings/profile',
      //   name: 'ReviewSettingsProfile',
      //   props: true,
      //   component: () => import('../views/admin/review/settings/Profile.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'Profile')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/billing/review-subscription',
      //   name: 'ReviewSettingsSubscription',
      //   props: true,
      //   component: () => import('../views/admin/review/settings/SubscriptionSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'Subscription')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/billing/review-bills',
      //   name: 'ReviewSettingsBills',
      //   props: true,
      //   component: () => import('../views/admin/review/settings/BillsSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'Bills')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/review/settings/account',
      //   name: 'ReviewSettingsAccount',
      //   props: true,
      //   component: () => import('../views/admin/review/settings/AccountSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'Account')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/review/api-key',
      //   name: 'ReviewApiKey',
      //   props: true,
      //   component: () => import('../views/admin/review/settings/ApiKey.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'API Key')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/settings',
      //   name: 'Settings',
      //   props: true,
      //   component: () => import('../views/admin/Settings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'settings')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/wallet',
      //   name: 'Wallet',
      //   props: true,
      //   component: () => import('../views/admin/Wallet.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'wallet')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/settings/general',
      //   name: 'SettingsGeneral',
      //   props: true,
      //   component: () => import('../views/admin/settings/main/GeneralSettings.vue'),
      // },
      // {
      //   path: '/admin/account',
      //   name: 'AccountSettings',
      //   props: true,
      //   component: () => import('../views/admin/settings/main/AccountSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'settings')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/settings/notifications',
      //   name: 'SettingNotifications',
      //   props: true,
      //   component: () => import('../views/admin/settings/main/NotificationsSettings.vue'),
      // },
      // {
      //   path: '/admin/billing/subscription',
      //   name: 'SubscriptionSettings',
      //   props: true,
      //   component: () => import('../views/admin/settings/main/SubscriptionSettings.vue'),
      // },
      // {
      //   path: '/admin/billing/bills',
      //   name: 'BillsSettings',
      //   props: true,
      //   component: () => import('../views/admin/settings/main/BillsSettings.vue'),
      // },
      // {
      //   path: '/admin/settings/payment',
      //   name: 'SettingsPayment',
      //   props: true,
      //   component: () => import('../views/admin/settings/main/PaymentSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'payment')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/settings/checkout',
      //   name: 'SettingsCheckout',
      //   props: true,
      //   component: () => import('../views/admin/settings/main/CheckoutSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'checkout')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/settings/advance',
      //   name: 'SettingsAdvanceOld',
      //   props: true,
      //   component: () => import('../views/admin/settings/main/AdvanceSettingsOld.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'advanced_setup')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/settings/advance-new',
      //   name: 'SettingsAdvance',
      //   props: true,
      //   component: () => import('../views/admin/settings/main/AdvanceSettings.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'advanced_setup')
      //     next()
      //   },
      // },
      // {
      //   path: '/admin/settings/advance-int',
      //   name: 'SettingsAdvanceInternational',
      //   props: true,
      //   component: () => import('../views/admin/settings/main/AdvanceSettingsInternational.vue'),
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'advanced_setup')
      //     next()
      //   },
      // },
      {
        path: '/admin/billing/bills/:id',
        name: 'BillDetails',
        props: true,
        component: () => import('../views/admin/billing/BillDetails.vue'),
      },
      {
        path: '/admin/billing/bills/:id/pay',
        name: 'PayBill',
        props: true,
        component: () => import('../views/admin/billing/PayBill.vue'),
      },
      {
        path: '/admin/billing/verify-payment',
        name: 'BillingVerifyPayment',
        props: true,
        component: () => import('../views/admin/billing/VerifyPayment.vue'),
      }
    ],
  },
  {
    path: '/pdf-qr',
    name: 'PdfQrCode',
    component: () => import('../views/PdfQrCode.vue'),
  },
  {
    path: '/print-invoices/:pid',
    name: 'PrintInvoiceHome',
    props: true,
    component: () => import('../views/invoice/Home.vue'),
  },
  {
    path: '/print-invoices-small/:pid',
    name: 'PrintInvoiceSmallHome',
    props: true,
    component: () => import('../views/invoice/Home.vue'),
  },
  {
    path: '/receipts/:pid',
    name: 'Invoice<->Receipt',
    props: true,
    component: () => import('../views/invoice/Home.vue'),
  },
  {
    path: '/quotations/:pid',
    name: 'Invoice<->Quotation',
    props: true,
    component: () => import('../views/invoice/Home.vue'),
  },
  {
    path: '/invoices/:pid',
    name: 'InvoiceHome',
    props: true,
    component: () => import('../views/invoice/Home.vue'),
    children: [
      {
        path: '/invoices/:pid/delivery',
        name: 'DeliveryOptionss',
        props: true,
        component: () => import('../views/invoice/UpdateDeliveryOptions.vue'),
      },
      {
        path: '/invoices/:pid/catalogs',
        name: 'UpdateProducts',
        props: true,
        component: () => import('../views/invoice/UpdateProducts.vue'),
      },
      {
        path: '/invoices/:pid/pay',
        name: 'PayInvoice',
        props: true,
        component: () => import('../views/invoice/PayInvoice.vue'),
      },
      {
        path: '/invoices/:pid/verify',
        name: 'VerifyPayment',
        props: true,
        component: () => import('../views/invoice/VerifyPayment.vue'),
      }
    ],
  },
  {
    path: '/upload-photo/:databinKey',
    name: 'UploadPhoto',
    props: true,
    component: () => import('../views/UploadPhoto.vue'),
  },
  {
    path: '/admin/marketing/merchant-app',
    name: 'MarketingMerchantApp',
    props: true,
    component: () => import('../views/admin/marketing/MerchantApp.vue'),
    beforeEnter: (to, from, next) => {
      store.commit('ui/setNavbarTitle', 'MarketingMerchantApp')
      next()
    },
    children: [
      {
        path: '/admin/marketing/merchant-app/home',
        name: 'MarketingMerchantAppHome',
        component: () => import('../views/admin/marketing/merchantapp/Home.vue')
      },
      {
        path: '/admin/marketing/merchant-app/pending',
        name: 'MarketingMerchantAppPending',
        component: () => import('../views/admin/marketing/merchantapp/Pending.vue')
      },
      {
        path: '/admin/marketing/merchant-app/collect',
        name: 'MarketingMerchantAppCollect',
        component: () => import('../views/admin/marketing/merchantapp/Collect.vue')
      },
      {
        path: '/admin/marketing/merchant-app/reviews',
        name: 'MarketingMerchantAppReviews',
        component: () => import('../views/admin/marketing/merchantapp/Reviews.vue')
      },
      {
        path: '/admin/marketing/merchant-app/you',
        name: 'MarketingMerchantAppYou',
        component: () => import('../views/admin/marketing/merchantapp/You.vue')
      },
    ]
  },
  {
    path: '/admin/hq',
    name: 'Headquarters',
    props: true,
    component: () => import('../views/admin/hq/Dashboard.vue'),
    beforeEnter: (to, from, next) => {
      store.commit('ui/setNavbarTitle', 'Headquarters')

      // Check if company is HQ before allowing navigation
      const company = store.getters.getCompany
      if (company && !company.is_hq) {
        store.commit('ui/setRedirectPath', null)
        next('/companies')
        return
      }

      store.commit('hq/setIsHq', true)

      next()
    },
    children: [
      {
        path: '/admin/hq/insights',
        name: 'HQInsight',
        component: () => import('../views/admin/hq/insights/Insights.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'insights')
          next()
        },
        children: [
          {
            path: '/admin/hq/insights/today',
            component: () => import('../views/admin/clinic/insights/Today.vue'),
            props: true,
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'Today')
              next()
            },
          },
          {
            path: '/admin/hq/insights/sales',
            component: () => import('../views/admin/clinic/insights/Sales.vue'),
            props: true,
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'Sales')
              next()
            },
          },
          {
            path: '/admin/hq/insights/in-clinic',
            component: () => import('../views/admin/clinic/insights/InClinic.vue'),
            props: true,
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'In-clinic')
              next()
            },
          },
          {
            path: '/admin/hq/insights/appointments',
            component: () => import('../views/admin/clinic/insights/Appointments.vue'),
            props: true,
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'Appointments')
              next()
            },
          },
          {
            path: '/admin/hq/insights/reviews',
            component: () => import('../views/admin/clinic/insights/Reviews.vue'),
            props: true,
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'Review')
              next()
            },
          },
          {
            path: '/admin/hq/insights/payments',
            component: () => import('../views/admin/clinic/insights/Payments.vue'),
            props: true,
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'Payments')
              next()
            },
          },
          {
            path: '/admin/hq/insights/inventory',
            component: () => import('../views/admin/clinic/insights/Inventory.vue'),
            props: true,
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'Inventory')
              next()
            },
          },
          {
            path: '/admin/hq/insights/patients',
            component: () => import('../views/admin/clinic/insights/Patients.vue'),
            props: true,
            beforeEnter: (to, from, next) => {
              store.commit('ui/setInsightTitle', 'Patients')
              next()
            },
          },
        ]
      },
      {
        path: '/admin/hq/patients',
        name: 'HQPatientList',
        props: true,
        component: () => import('../views/admin/hq/Patients.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'patient')
          next()
        },
      },
      {
        path: '/admin/hq/patient/:id',
        name: 'HQPatientDetails',
        props: true,
        component: () => import('../views/admin/hq/Patient.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'patient')
          next()
        },
      },
      {
        path: '/admin/hq/checkout/:pid',
        name: 'HQCheckout',
        props: true,
        component: () => import('../views/admin/clinic/Checkout.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Checkout')
          next()
        }
      },
      {
        path: '/admin/hq/invoice/:pid',
        name: 'HQInvoice',
        props: true,
        component: () => import('../views/admin/clinic/Invoice.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Invoice')
          next()
        }
      },
      {
        path: '/admin/hq/inventory',
        component: () => import('../views/admin/hq/inventory/Inventory.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory')
          next()
        },
        children: [
          {
            path: '',
            name: 'HQInventoryHome',
            component: () => import('../views/admin/hq/inventory/InventoryHome.vue')
          },
          {
            path: 'services',
            name: 'HQInventoryServices',
            component: () => import('../views/admin/hq/inventory/Services.vue')
          },
          {
            path: 'packages',
            name: 'HQInventoryPackages',
            component: () => import('../views/admin/hq/inventory/Packages.vue')
          },
          {
            path: 'stock-take',
            name: 'HQInventoryStockTake',
            component: () => import('../views/admin/hq/inventory/StockTake.vue')
          },
          {
            path: 'branches-warehouses',
            name: 'HQInventoryBranchesWarehouses',
            component: () => import('../views/admin/hq/inventory/BranchesWarehouses.vue')
          },
          {
            path: 'storage-locations',
            name: 'HQInventoryStorageLocations',
            component: () => import('../views/admin/hq/inventory/StorageLocations.vue')
          },
          {
            path: 'list',
            name: 'HQInventoryList',
            component: () => import('../views/admin/hq/inventory/List.vue')
          }
        ]
      },
      {
        path: '/admin/hq/inventory/medication/:id/stock-history',
        name: 'HQStockHistory',
        props: true,
        component: () => import('../views/admin/hq/inventory/HqStockHistory.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Stock History')
          next()
        },
      },
      {
        path: '/admin/hq/inventory/service/:id/service-history',
        name: 'HQServiceHistory',
        props: true,
        component: () => import('../views/admin/hq/inventory/HqServiceHistory.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Service History')
          next()
        },
      },
      {
        path: '/admin/hq/inventory/storage-location',
        name: 'HQAddStorageLocation',
        component: () => import('../views/admin/hq/inventory/StorageLocation.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory')
          next()
        },
      },
      {
        path: '/admin/hq/inventory/storage-location/:id',
        name: 'HQEditStorageLocation',
        props: true,
        component: () => import('../views/admin/hq/inventory/StorageLocation.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory')
          next()
        },
      },
      {
        path: '/admin/hq/inventory/stock-take/:id',
        name: 'HQStockTakeDetail',
        props: true,
        component: () => import('../views/admin/hq/inventory/StockTakeDetail.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory')
          next()
        },
      },
      {
        path: '/admin/hq/inventory/stock-take/:id/summary',
        name: 'HQStockTakeSummary',
        props: true,
        component: () => import('../views/admin/hq/inventory/StockTakeSummary.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory')
          next()
        },
      },
      {
        path: '/admin/hq/inventory/service',
        name: 'HQNewService',
        props: true,
        component: () => import('../views/admin/hq/inventory/Service.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory')
          next()
        },
      },
      {
        path: '/admin/hq/inventory/service/:id',
        name: 'HQEditService',
        props: true,
        component: () => import('../views/admin/hq/inventory/Service.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory')
          next()
        },
      },
      {
        path: '/admin/hq/inventory/package',
        name: 'HQNewPackage',
        props: true,
        component: () => import('../views/admin/hq/inventory/Package.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory')
          next()
        },
      },
      {
        path: '/admin/hq/inventory/package/:id',
        name: 'HQEditPackage',
        props: true,
        component: () => import('../views/admin/hq/inventory/Package.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory')
          next()
        },
      },
      {
        path: '/admin/hq/inventory/package/:id/package-history',
        name: 'HQPackageHistory',
        props: true,
        component: () => import('../views/admin/hq/inventory/HqPackageHistory.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'Package History')
          next()
        },
      },
      // TODO: Re-enable HQ Purchase Hub route when feature is ready
      // {
      //   path: '/admin/hq/purchase-hub',
      //   name: 'HQPurchaseHub',
      //   component: () => import('../views/admin/hq/PurchaseHub.vue'),
      //   props: true,
      //   beforeEnter: (to, from, next) => {
      //     store.commit('ui/setNavbarTitle', 'purchase hub')
      //     next()
      //   },
      // },
      {
        path: '/admin/hq/bookings',
        name: 'HQBookings',
        component: () => import('../views/admin/hq/Bookings.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'bookings')
          next()
        },
      },
      {
        path: '/admin/hq/bookings/calendar',
        name: 'HQBookingsCalendar',
        props: true,
        component: () => import('../views/admin/hq/BookingsCalendar.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'calendar')
          next()
        },
      },
      {
        path: '/admin/hq/notifications',
        name: 'HQNotifications',
        component: () => import('../views/admin/hq/Notifications.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'notifications')
          next()
        },
      },
      {
        path: '/admin/hq/menu',
        name: 'HQMenu',
        component: () => import('../views/admin/hq/settings/Menu.vue'),
        props: {isHq: true},
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'menu')
          next()
        },
      },
      {
        path: '/admin/hq/settings/account',
        component: () => import('../views/admin/clinic/settings/AccountSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'menu')
        next()
        },
      },
      {
        path: '/admin/hq/inventory/settings',
        component: () => import('../views/admin/hq/settings/GeneralSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'inventory')
          next()
        },
        children: [
          {
            path: '',
            redirect: 'price-tier'
          },
          {
            path: 'price-tier',
            name: 'HQInventorySettingsPriceTier',
            component: () => import('../views/admin/hq/inventory/settings/PriceTier.vue')
          },
          {
            path: 'medicine-details',
            name: 'HQInventorySettingsMedicineDetails',
            component: () => import('../views/admin/hq/inventory/settings/MedicineDetails.vue')
          },
          {
            path: 'suppliers',
            name: 'HQInventorySettingsSuppliers',
            component: () => import('../views/admin/hq/inventory/settings/Suppliers.vue')
          },
          {
            path: 'payment-methods',
            name: 'HQInventorySettingsPaymentMethods',
            component: () => import('../views/admin/hq/inventory/settings/PaymentMethods.vue')
          },
          {
            path: 'inventory-creation',
            name: 'HQInventorySettingsCreation',
            component: () => import('../views/admin/hq/inventory/settings/InventoryCreation.vue')
          }
        ]
      },
      {
        path: '/admin/hq/billing/subscription',
        component: () => import('../views/admin/hq/settings/SubscriptionSettings.vue'),
        beforeEnter: (to, from, next) => {
          store.commit('ui/setNavbarTitle', 'subscriptions')
        next()
        },
      },
    ]
  },
  {
    path: '/signin/merchant-app',
    name: 'SignInMerchantApp',
    component: () => import('../views/SignIn.vue'),
    props: true,
  },
  {
    path: '/signout/merchant-app',
    name: 'SignOutMerchantApp',
    component: () => import('../views/SignOut.vue'),
    props: true,
  },
  {
    path: '/companies/merchant-app',
    name: 'CompaniesMerchantApp',
    component: () => import('../views/Companies.vue'),
  },
  {
    path: '/no-subscription-warning',
    name: 'NoSubscriptionWarning',
    component: () => import('../views/NoSubscriptionWarning.vue'),
    props: true,
  },
  {
    path: '/_design_docs/components',
    name: 'DesignSystemDocsComponents',
    component: () => import('../views/DesignSystemDocs.vue'),
    redirect: '/_design_docs/components/typography',
    children: [
      {
        path: 'button',
        name: 'DesignSystemButton',
        component: () => import('../components/designdocs/components/Buttons.vue'),
      },
      {
        path: 'btn-toggle',
        name: 'DesignSystemBtnToggle',
        component: () => import('../components/designdocs/components/BtnToggle.vue'),
      },
      {
        path: 'radio',
        name: 'DesignSystemRadio',
        component: () => import('../components/designdocs/components/Radio.vue'),
      },
      {
        path: 'checkbox',
        name: 'DesignSystemCheckbox',
        component: () => import('../components/designdocs/components/Checkbox.vue'),
      },
      {
        path: 'switch',
        name: 'DesignSystemSwitch',
        component: () => import('../components/designdocs/components/Switch.vue'),
      },
      {
        path: 'icon',
        name: 'DesignSystemIcon',
        component: () => import('../components/designdocs/components/Icon.vue'),
      },
      {
        path: 'typography',
        name: 'DesignSystemTypography',
        component: () => import('../components/designdocs/components/Typography.vue'),
      },
      {
        path: 'colors',
        name: 'DesignSystemColors',
        component: () => import('../components/designdocs/components/Colors.vue'),
      },
      {
        path: 'textfield',
        name: 'DesignSystemTextField',
        component: () => import('../components/designdocs/components/TextField.vue'),
      },
      {
        path: 'textarea',
        name: 'DesignSystemTextarea',
        component: () => import('../components/designdocs/components/Textarea.vue'),
      },
      {
        path: 'address-input',
        name: 'DesignSystemAddressInput',
        component: () => import('../components/designdocs/components/AddressInput.vue'),
      },
      {
        path: 'toast',
        name: 'DesignSystemToast',
        component: () => import('../components/designdocs/components/Toast.vue'),
      },
      {
        path: 'menu',
        name: 'DesignSystemMenu',
        component: () => import('../components/designdocs/components/Menu.vue'),
      },
      {
        path: 'filter-menu',
        name: 'DesignSystemFilterMenu',
        component: () => import('../components/designdocs/components/FilterMenu.vue'),
      },
      {
        path: 'dropdown',
        name: 'DesignSystemDropdown',
        component: () => import('../components/designdocs/components/Dropdown.vue'),
      },
      {
        path: 'api-dropdown',
        name: 'DesignSystemApiDropdown',
        component: () => import('../components/designdocs/components/ApiDropdown.vue'),
      },
      {
        path: 'divider',
        name: 'DesignSystemDivider',
        component: () => import('../components/designdocs/components/Divider.vue'),
      },
      {
        path: 'card',
        name: 'DesignSystemCard',
        component: () => import('../components/designdocs/components/Card.vue'),
      },
      {
        path: 'empty-state-card',
        name: 'DesignSystemEmptyStateCard',
        component: () => import('../components/designdocs/components/EmptyStateCard.vue'),
      },
      {
        path: 'badge',
        name: 'DesignSystemBadge',
        component: () => import('../components/designdocs/components/Badge.vue'),
      },
      {
        path: 'dot',
        name: 'DesignSystemDot',
        component: () => import('../components/designdocs/components/Dot.vue'),
      },
      {
        path: 'dialog',
        name: 'DesignSystemDialog',
        component: () => import('../components/designdocs/components/Dialog.vue'),
      },
      {
        path: 'delete-confirmation-dialog',
        name: 'DesignSystemDeleteConfirmationDialog',
        component: () => import('../components/designdocs/components/DeleteConfirmationDialog.vue'),
      },
      {
        path: 'truncated-list',
        name: 'DesignSystemTruncatedList',
        component: () => import('../components/designdocs/components/TruncatedList.vue'),
      },
      {
        path: 'radio-selection-card',
        name: 'DesignSystemRadioSelectionCard',
        component: () => import('../components/designdocs/components/RadioSelectionCard.vue'),
      },
      {
        path: 'checkbox-selection-card',
        name: 'DesignSystemCheckboxSelectionCard',
        component: () => import('../components/designdocs/components/CheckboxSelectionCard.vue'),
      },
      {
        path: 'tooltip',
        name: 'DesignSystemTooltip',
        component: () => import('../components/designdocs/components/Tooltip.vue'),
      },
      {
        path: 'pagination',
        name: 'DesignSystemPagination',
        component: () => import('../components/designdocs/components/Pagination.vue'),
      },
      {
        path: 'phone-input',
        name: 'DesignSystemPhoneInput',
        component: () => import('../components/designdocs/components/PhoneInput.vue'),
      },
      {
        path: 'date-picker',
        name: 'DesignSystemDatePicker',
        component: () => import('../components/designdocs/components/DatePicker.vue'),
      },
      {
        path: 'img',
        name: 'DesignSystemImage',
        component: () => import('../components/designdocs/components/Image.vue'),
      },
      {
        path: 'avatar',
        name: 'DesignSystemAvatar',
        component: () => import('../components/designdocs/components/Avatar.vue'),
      },
      {
        path: 'responsive',
        name: 'DesignSystemResponsive',
        component: () => import('../components/designdocs/components/Responsive.vue'),
      },
      {
        path: 'data-table',
        name: 'DesignSystemDataTable',
        component: () => import('../components/designdocs/components/DataTable.vue'),
      },
      {
        path: 'upload-button',
        name: 'DesignSystemUploadButton',
        component: () => import('../components/designdocs/components/UploadButton.vue'),
      },
      {
        path: 'upload-card',
        name: 'DesignSystemUploadCard',
        component: () => import('../components/designdocs/components/UploadCard.vue'),
      },
      {
        path: 'upload-qr-databin',
        name: 'DesignSystemUploadQrDatabin',
        component: () => import('../components/designdocs/components/UploadQrDatabin.vue'),
      },
      {
        path: 'file-preview',
        name: 'DesignSystemFilePreview',
        component: () => import('../components/designdocs/components/FilePreview.vue'),
      },
      {
        path: 'tabs',
        name: 'DesignSystemTabs',
        component: () => import('../components/designdocs/components/Tabs.vue'),
      },
      {
        path: 'search-button',
        name: 'DesignSystemSearchButton',
        component: () => import('../components/designdocs/components/SearchButton.vue'),
      },
      {
        path: 'progress-linear',
        name: 'DesignSystemProgressLinear',
        component: () => import('../components/designdocs/components/ProgressLinear.vue'),
      },
      {
        path: 'progress-circular',
        name: 'DesignSystemProgressCircular',
        component: () => import('../components/designdocs/components/ProgressCircular.vue'),
      },
    ]
  },
  {
    path: '*',
    redirect: '/admin/dashboard',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  },
  routes
})

window.$router = router

export default router
